import { IndentState, useIndent, useTheme, SetState } from "@tableplus/toolkit";

export interface Prefs extends IndentState {
    theme: string;
    setTheme: SetState<string>;
}

export const usePrefs = (): Prefs => {
    const indent = useIndent();
    const { theme, setTheme } = useTheme();
    return { theme, setTheme, ...indent };
};
